module.exports = __webpack_public_path__ + "dfc58408158ee7c0110ec694ee4eefe5.png";